export type DatePreset = 'all' | '7d' | '30d' | 'this_month' | 'last_month' | 'this_year'

export type DateFilter = { kind: 'preset'; preset: DatePreset } | { kind: 'custom'; start: Date; end: Date }

export type UsageFiltersState = {
  date: DateFilter
  appKeys: string[]
  appCategories: string[]
  userIds: string[]
  teamId: string | null
}

export const DEFAULT_FILTERS: UsageFiltersState = {
  date: { kind: 'preset', preset: 'all' },
  appKeys: [],
  appCategories: [],
  userIds: [],
  teamId: null,
}
